// 無權限 — shown when an authenticated principal lacks an admin role
// (RequireAdmin gate). Offers logout so a wrong account can switch out.

import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { roleLabel } from '../users/userModel';
import '../login/auth.css';

export default function DeniedPage() {
  const { role, user, logout } = useAuth();
  return (
    <div className="auth-shell">
      <section className="card auth-card auth-card--wide">
        <div className="empty-state">
          <div className="empty-state-icon" aria-hidden="true">
            ⛔
          </div>
          <h1 className="empty-state-title">無權限</h1>
          <p className="empty-state-detail">
            此帳號沒有管理主控台的存取權限。需要 <code>admin</code> 或 <code>security-officer</code> 角色。
          </p>
          <p className="text-tertiary" style={{ margin: 0, fontSize: 'var(--font-size-sm)' }}>
            目前登入：{user?.email ?? '（未知）'}
            {role ? `（${roleLabel(role)}）` : ''}
          </p>
          <div className="empty-state-actions">
            <button className="btn-primary" onClick={() => void logout()}>
              登出
            </button>
            <Link className="btn-ghost" to="/login">
              返回登入
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
